// ═══════════════════════════════════════════════════════════════════
//  ATTENDEE CONTACT DETAILS THAT ARE NOT REAL
//
//  Cal requires an attendee email on every booking, and plenty of
//  applicants do not have one — they book by phone, or at a counter with
//  a shut-off notice in hand. CMS fills the gap with a synthetic address
//  rather than refusing the appointment.
//
//  That address is per-booking, not shared: `unknown+<tag>@example.com`,
//  where the tag is the slot reservation. See
//  `AttendeeInformation.UnknownEmailFor` for why a single shared
//  placeholder silently merged strangers' bookings.
//
//  Per-booking tagging is what makes it unrecognisable on screen: it
//  looks like an ordinary address, so a booking read out over the phone
//  or followed up by email would be read out or written to. Nothing on
//  the server marks it, so the UI has to recognise the shape.
// ═══════════════════════════════════════════════════════════════════

/**
 * The placeholder address, tagged or bare — `AttendeeInformation.UnknownEmail` and everything
 * `UnknownEmailFor` derives from it.
 *
 * The tag is matched loosely rather than as the letters-and-digits the server currently writes: the
 * risk of showing a placeholder as a real address is worse than the risk of a genuine applicant
 * having signed up at example.com, which is a reserved domain nobody receives mail at.
 */
const PLACEHOLDER_EMAIL = /^unknown(\+[^@]*)?@example\.com$/i

/**
 * Whether this is the address CMS invents for an applicant who gave none, rather than one somebody
 * actually supplied.
 */
export function isPlaceholderEmail(email: string | undefined): boolean {
  return PLACEHOLDER_EMAIL.test((email ?? "").trim())
}
